import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createBlock as _createBlock, vShow as _vShow, withDirectives as _withDirectives, Transition as _Transition, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '../../static/images/play.png'


const _withScopeId = n => (_pushScopeId("data-v-afecddd8"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "ins-banner" }
const _hoisted_2 = ["src"]
const _hoisted_3 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "meng" }, null, -1))
const _hoisted_4 = { class: "txt padding" }
const _hoisted_5 = ["innerHTML"]
const _hoisted_6 = { class: "bread padding" }
const _hoisted_7 = { class: "bd" }
const _hoisted_8 = /*#__PURE__*/_createTextVNode("首页")
const _hoisted_9 = /*#__PURE__*/_createTextVNode("科研实力")
const _hoisted_10 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("span", null, "智慧工厂", -1))
const _hoisted_11 = { class: "ins-nav-box" }
const _hoisted_12 = { class: "ins-nav" }
const _hoisted_13 = { class: "wisd padding" }
const _hoisted_14 = { class: "flex" }
const _hoisted_15 = { class: "c-title" }
const _hoisted_16 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("div", { class: "line" }, null, -1))
const _hoisted_17 = ["innerHTML"]
const _hoisted_18 = ["innerHTML"]
const _hoisted_19 = { class: "wisd-video" }
const _hoisted_20 = { class: "bg" }
const _hoisted_21 = ["src"]
const _hoisted_22 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: _imports_0,
  alt: ""
}, null, -1))
const _hoisted_23 = [
  _hoisted_22
]
const _hoisted_24 = ["src"]
const _hoisted_25 = ["poster", "src"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Header = _resolveComponent("Header")!
  const _component_router_link = _resolveComponent("router-link")!
  const _component_Footer = _resolveComponent("Footer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_Header),
    _createElementVNode("div", _hoisted_1, [
      _createElementVNode("img", {
        src: _ctx.banner.banner,
        alt: "",
        class: "img"
      }, null, 8, _hoisted_2),
      _hoisted_3,
      _createElementVNode("div", _hoisted_4, [
        _createElementVNode("h5", null, _toDisplayString(_ctx.parent.name), 1),
        _createElementVNode("h3", {
          innerHTML: _ctx.parent.text
        }, null, 8, _hoisted_5)
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_router_link, { to: "/" }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 1
          }),
          _createVNode(_component_router_link, { to: "/research" }, {
            default: _withCtx(() => [
              _hoisted_9
            ]),
            _: 1
          }),
          _hoisted_10
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_11, [
      _createElementVNode("div", _hoisted_12, [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.navs, (item) => {
          return (_openBlock(), _createBlock(_component_router_link, {
            to: item.route,
            key: item.id,
            class: _normalizeClass(_ctx.route.path == item.route ? 'link active' : 'link')
          }, {
            default: _withCtx(() => [
              _createTextVNode(_toDisplayString(item.name), 1)
            ]),
            _: 2
          }, 1032, ["to", "class"]))
        }), 128))
      ])
    ]),
    _createElementVNode("div", _hoisted_13, [
      _createElementVNode("div", _hoisted_14, [
        _createElementVNode("div", _hoisted_15, [
          _createElementVNode("h4", null, _toDisplayString(_ctx.banner.name), 1),
          _hoisted_16,
          _createElementVNode("div", {
            class: "con",
            innerHTML: _ctx.banner.f_title
          }, null, 8, _hoisted_17)
        ]),
        _createElementVNode("div", {
          class: "desc",
          innerHTML: _ctx.banner.text
        }, null, 8, _hoisted_18)
      ]),
      _withDirectives(_createElementVNode("div", _hoisted_19, [
        _createElementVNode("div", _hoisted_20, [
          _createElementVNode("img", {
            src: _ctx.video.image,
            alt: "",
            class: "img"
          }, null, 8, _hoisted_21),
          _createElementVNode("div", {
            class: "play",
            onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.openVideo && _ctx.openVideo(...args)))
          }, _hoisted_23)
        ])
      ], 512), [
        [_vShow, _ctx.video.file]
      ]),
      _createElementVNode("img", {
        src: _ctx.banner.image,
        alt: "",
        class: "img"
      }, null, 8, _hoisted_24)
    ]),
    _createVNode(_Transition, { name: "el-fade-in" }, {
      default: _withCtx(() => [
        _withDirectives(_createElementVNode("div", {
          class: "video-box",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.closeVideo && _ctx.closeVideo(...args)))
        }, [
          _createElementVNode("video", {
            poster: _ctx.video.image,
            src: _ctx.video.file,
            controls: "",
            ref: "vdRef"
          }, null, 8, _hoisted_25)
        ], 512), [
          [_vShow, _ctx.videoShow]
        ])
      ]),
      _: 1
    }),
    _createVNode(_component_Footer)
  ], 64))
}